<!-- 模型等级 -->
<template>
  <div
    class="aboutNode"
    :style="{backgroundImage: 'url(' + (bgimage ? bgimage : baseImg) + ')', backgroundSize:'contain'}"
  >
    <h3 class="h3">{{title}}</h3>
    <div class="aboutCon width">
      <div class="aboutInt">
        <p v-for="(item,i) in content" :key="i">{{item}}</p>
      </div>
      <div class="aboutImg">
        <img :src="image" alt srcset />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    title: String,
    content: Array,
    image: String,
    bgimage: String,
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.aboutNode {
  padding-top: 20px;
  height: 640px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    color: #fff;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .aboutCon {
    display: flex;
    justify-content: center;
    align-items: center;
    .aboutInt {
      flex: 1;
      letter-spacing: 1px;
      line-height: 30px;
      text-indent: 2em;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      margin-right: 20px;
    }
    .aboutImg {
      flex: 1;
    }
  }
}
</style>
